import { render } from "./as-switch.vue?vue&type=template&id=384f7371&scoped=true&ts=true"
import script from "./as-switch.vue?vue&type=script&lang=ts"
export * from "./as-switch.vue?vue&type=script&lang=ts"

import "./as-switch.vue?vue&type=style&index=0&id=384f7371&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384f7371"]])

export default __exports__